import { Route } from '@angular/router';
import { RoutingID } from '../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { TemplateDatasetComponent } from '../../../../pages/media/template-dataset/template-dataset.component';
import { TemplateDatasetEditComponent } from '../../../../pages/media/template-dataset/template-dataset-edit/template-dataset-edit.component';
import { templateDatasetEntries } from './templateDatasetEntries';

export const templateDatasets: Route = {
  path: 'template-datasets',
  title: 'nav.templateDatasets',
  data: {
    icon: SbIcons.templateEntry,
    breadcrumb: 'nav.templateDatasets',
    id: RoutingID.templateDatasets,
  },
  children: [
    {
      path: '',
      component: TemplateDatasetComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'template-datasets-edit/:templateDatasetID',
      title: 'nav.templateGroup.details',
      data: {
        breadcrumb: 'nav.templateGroup.details',
        icon: SbIcons.edit,
        id: RoutingID.templateDatasetEdit,
      },
      children: [
        {
          path: '',
          component: TemplateDatasetEditComponent,
        },
      ],
    },
    {
      path: 'template-dataset-create',
      title: 'nav.templateSources.create',
      data: {
        breadcrumb: 'nav.templateSources.create',
        icon: SbIcons.plus,
        id: RoutingID.templateDatasetCreate,
      },
      children: [
        {
          path: '',
          component: TemplateDatasetEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    templateDatasetEntries,
  ],
};
